/* globals Spectrum, tinycolor */
import {
  forwardRef,
  Component,
  ElementRef,
  Input,
  HostBinding,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BrowserService } from '@core/browser.service';

@Component({
  selector: 'zbp-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ColorPickerComponent),
    multi: true,
  }],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColorPickerComponent implements ControlValueAccessor, OnInit {
  value: FormControl;

  @Input() color: string = '#FFB057';
  @Input() useNative: boolean = true;
  @HostBinding('attr.id') id: string = 'colorPickerInput';
  @HostBinding('attr.name') name: string = 'color';
  @HostBinding('attr.aria-labelledby') labelId: string;

  @ViewChild('input', { static: true }) input: ElementRef;

  constructor(private browserService: BrowserService) {
    this.value = new FormControl();
  }

  ngOnInit() {
    if (!this.useNative || this.browserService.isIE || this.browserService.isLegacyIOSDevice) {
      $(this.input.nativeElement).spectrum({
        showInput: false,
        showButtons: true,
        showPalette: true,
        showPaletteOnly: true,
        showInitial: true,
        showAlpha: false,
        // Needs to be true even though it does not actually hide with showPaletteOnly.
        hideAfterPaletteSelect: true,
        flat: true,
        color: this.color,
        preferredFormat: 'hex',
        change: (color: tinycolor.Instance) => this.onChange(color.toHexString()),
        appendTo: $('.modal-body'),
      } as Spectrum.Options);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (_: any) => {
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onTouched = (_: any) => {
  };

  registerOnChange(fn: (_: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: (_: any) => void) {
    this.onTouched = fn;
  }

  writeValue(value?: string): void {
    if (value) {
      this.value.setValue(value);
    }
  }

  inputChanged() {
    if (this.useNative && !this.browserService.isIE && !this.browserService.isLegacyIOSDevice) {
      this.onChange(this.value.value);
    }
  }
}
